import {
  getDefaultDateRangePreset,
  RANGE_DATE_PRESET,
} from '@/components/FilterBar/constants/rangeDateOptions';

export const ALL = 'all';

export const SCOPE = {
  BRANCHES: 'branches',
  TEAMS: 'teams',
  AGENTS: 'agents',
};

export const DISTRIBUTION = {
  UNASSIGNED: 'unassigned',
  MANUAL: 'manual',
  RULE: 'rule',
  DELETED: 'deleted',
};

export const RESULT = {
  UNATTENDED: 'unattended',
  LOST: 'lost',
  IN_PROGRESS: 'in_progress',
  WON: 'won',
};

export const SEARCH_FIELD = {
  CONTACT: 'contact',
  ORIGIN: 'origin',
  PROPERTY: 'property',
  PROPERTY_TYPE: 'property_type',
  AGENT: 'agent',
};

export const OPERATION = {
  ALL: 'all',
  SALE: 'sale',
  RENT: 'rent',
  TEMPORARY_RENT: 'temporary_rent',
};

export const NONE_ORIGIN = 'none';

export const PAGE_SIZE = 50;

/** Maps UI preset ids to assignment-report API `period` values. */
export const RANGE_DATE_TO_PERIOD = {
  [RANGE_DATE_PRESET.LAST_7_DAYS]: 'last_7_days',
  [RANGE_DATE_PRESET.LAST_30_DAYS]: 'last_30_days',
  [RANGE_DATE_PRESET.LAST_90_DAYS]: 'last_90_days',
  [RANGE_DATE_PRESET.LAST_SIX_MONTHS]: 'last_6_months',
  [RANGE_DATE_PRESET.LAST_YEAR]: 'last_year',
};

/**
 * Period values accepted by older assignment-report backends. Sending anything
 * else as `period` would 400 if React ships before Django.
 */
export const LEGACY_ASSIGNMENT_REPORT_PERIODS = new Set([
  'last_7_days',
  'last_30_days',
  'last_90_days',
]);

const defaultPreset = getDefaultDateRangePreset();

export const DEFAULT_DATE_RANGE = {
  id: defaultPreset.id,
  value: defaultPreset.value,
};

// Empty origin or scope lists mean "all", same as the dashboard filters.
export const DEFAULT_FILTERS = {
  originKeys: [],
  scope: SCOPE.BRANCHES,
  scopeIds: [],
  dateRange: DEFAULT_DATE_RANGE,
};

export const ASSIGNMENT_REPORT_PATH = '/marketing/webcontact/config/report';

/** Query `origin` values for platform_assignment-report_open. */
export const ASSIGNMENT_REPORT_ORIGIN = {
  DASHBOARD_CARD_LINK: 'dashboard-card-link',
  INQUIRIES_CONFIG_TAB: 'inquiries-config-tab',
};

export const ASSIGNMENT_REPORT_EVENT = {
  CONFIG_OPEN: 'platform_inquiries-config_open',
  REPORT_OPEN: 'platform_assignment-report_open',
  TABLE_OPEN: 'platform_assignment-report_table-open',
  FILTER_APPLIED: 'platform_assignment-report_filter-applied',
};

export const REPORT_ASSIGNMENT_RULES_FLAG = 'report_assignment_rules';
